import root from "../../../src/root";
import { EditorAppContent } from "./components/AppContent/EditorAppContent";
import { editorSiteOidc } from "./utils/oidcConfig";

root(EditorAppContent, editorSiteOidc);
